function ArrowSwapHorizontal() {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="none"
                  viewBox="0 0 16 16"
            >
                  <path
                        stroke="#005BB2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        strokeWidth="1.5"
                        d="M9.993 2.333l3.347 3.34M9.993 13.667V2.334M6.007 13.667l-3.347-3.34M6.007 2.334v11.333"
                  ></path>
            </svg>
      );
}

export default ArrowSwapHorizontal;
